export default "__VITE_ASSET__BYpEvDNe__"